import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,{staticClass:"token-cooldown-time-bucket-picker",attrs:{"value":_vm.value,"items":_vm.timeBucketItems,"item-text":"label","item-value":"value","outlined":"","dense":"","disabled":_vm.disabled,"hide-details":_vm.hideDetails},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }